const nodeFetch = require('node-fetch');
const ReLogin = require('../components/authentication/ReLogin');
const { getAuthToken } = require('../components/authentication/Authentication');

const handleResponse = response => {
  if (response.headers.get('content-length') === '0' || response.status === 204) {
    return null;
  }
  const json = response.json(); // TODO: support other response types

  if (response.status === 401) {
    ReLogin();
  }

  if (response.status === 403) {
    ReLogin();
  }

  // TODO: support custom acceptable statuses
  return json;
};

const fetch = (url, options) => {
  if (options && options.headers) {
    options.headers.Authorization = `Bearer ${getAuthToken('id_token')}`;
  }
  return nodeFetch(url, options)
    .then(handleResponse)
    .catch(
      e => {
        return { errors: [{ message: e.message }] };
      }
      //
    );
};

const fetchWithoutToken = (url, options) =>
  nodeFetch(url, options)
    .then(handleResponse)
    .catch(e => ({ errors: [{ message: e.message }] }));

const exportData = (url, options) => {
  // return fetch(`${url}${ORDERS_UPDATE}`, merge(init, options)).then(handleResponse);
  options.headers.Authorization = `Bearer ${getAuthToken('id_token')}`;
  return nodeFetch(url, options)
    .then(res => {
      let filename = 'file.csv';
      const disposition = res.headers.get('Content-disposition');
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      res.text().then(text => {
        const blob = new Blob([text]);
        if (window.navigator.msSaveOrOpenBlob) {
          // IE hack
          window.navigator.msSaveBlob(blob, filename);
        } else {
          const a = window.document.createElement('a');
          a.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
          a.download = filename;
          document.body.appendChild(a);
          a.click(); // IE: "Access is denied"
          document.body.removeChild(a);
        }
      });
      return [];
    })
    .catch(error => [error]);
};

module.exports = { fetch, exportData, fetchWithoutToken };



// WEBPACK FOOTER //
// ./src/api/Fetch.js